import React from 'react';
import { Outlet } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';

export default function AdminApp() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}
